import { Pipe, PipeTransform } from '@angular/core';

import { parseDate } from '../workflow-log.mapper';

const MOSCOW_DAY_FORMATTER = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  day: '2-digit',
  month: '2-digit',
});

@Pipe({
  name: 'moscowDay',
  standalone: true,
})
export class MoscowDayPipe implements PipeTransform {
  public transform(value: string | Date): string {
    const date = parseDate(value);

    return date ? MOSCOW_DAY_FORMATTER.format(date) : '--.--';
  }
}
